import { useQuery } from '@tanstack/react-query'

import { visitorParkingAPI } from '@/api/new-api'

interface GetVisitorParkingCalculationRequest {
  duration: number
}

interface GetVisitorParkingCalculationResponse {
  amount: number
  endDate: number
}

export const getVisitorParkingCalculationQueryKey = (data: GetVisitorParkingCalculationRequest) => [
  'useGetVisitorParkingCalculation',
  data,
]

export const getVisitorParkingCalculation = async (data: GetVisitorParkingCalculationRequest) => {
  const response = await visitorParkingAPI.get<GetVisitorParkingCalculationResponse>(
    `/visitor-parking/calculate-visitor-parking-fee`,
    {
      params: data,
    },
  )
  return response.data
}

export const useGetVisitorParkingCalculation = (data: GetVisitorParkingCalculationRequest) => {
  return useQuery({
    // Note: This query is not cached to avoid stale data. The approx end time is calculated on the fly.
    gcTime: 0,
    queryFn: () => getVisitorParkingCalculation(data),
    queryKey: getVisitorParkingCalculationQueryKey(data),
    staleTime: 0,
  })
}
